export const ENV = {
	HOST: import.meta.env.VITE_SERVER_HOST,
	PORT: import.meta.env.VITE_SERVER_PORT,
	GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "",
};

// Compose the full URL
export const SERVER_URL = `${ENV.HOST}${ENV.PORT ? `:${ENV.PORT}` : ""}`;
